import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import * as config from '../../config';



// Define a service using a base URL and expected endpoints
export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl: config.base_api_url }),
  endpoints: (builder) => ({
    signinUser: builder.mutation({
      query: (body: { email: string; password: string }) => {
        return {
          url: "/v1/auth/login",
          method: "post",
          body,
        };
      },
    }),
    signupUser: builder.mutation({
      query: (body: { firstName: string; lastName: string; email: string; password: string, role: string, isActive: boolean, watchProducts: number[] }) => {
        return {
          url: "/v1/auth/signup",
          method: "post",
          body,
        };
      },
    }),
    sendMailForVerification: builder.mutation({
      query: (body: { email: string }) => {
        return {
          url: "/v1/auth/email/resend-verification",
          method: "post",
          body,
        };
      },
    }),
    verifyUser: builder.mutation({
      query: (body: { token: string }) => {
        return {
          url: "v1/auth/email/verify",
          method: "post",
          body,
        };
      },
    }),
    sendMailForgotPassword: builder.mutation({
      query: (body: { email: string }) => {
        return {
          url: "v1/auth/email/forgot-password",
          method: "post",
          body,
        };
      },
    }),
    resetPassword: builder.mutation({
      query: (body: { newPasswordToken: string; newPassword: string }) => {
        return {
          url: "v1/auth/email/reset-password",
          method: "post",
          body,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSigninUserMutation,
  useSignupUserMutation,
  useSendMailForVerificationMutation,
  useVerifyUserMutation,
  useSendMailForgotPasswordMutation,
  useResetPasswordMutation
} = authApi;
